import { render, staticRenderFns } from "./home-how-it-works.vue?vue&type=template&id=7af69a88&scoped=true&"
import script from "./home-how-it-works.vue?vue&type=script&lang=js&"
export * from "./home-how-it-works.vue?vue&type=script&lang=js&"
import style0 from "./home-how-it-works.vue?vue&type=style&index=0&id=7af69a88&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af69a88",
  null
  
)

export default component.exports